export const BRAND = '#8FC150';
export const BRAND_HOVER = '#7eae43';
export const BRAND_SOFT = 'rgba(143, 193, 80, 0.15)';

export const PERIOD_OPTIONS = [
  { value: 7, label: '7 days' },
  { value: 14, label: '14 days' },
  { value: 30, label: '30 days' },
];

export const ACTIVITY_LABELS = {
  login: 'Logged in',
  logout: 'Logged out',
  view_property: 'Viewed property',
  view_unit: 'Viewed unit',
  view_project: 'Viewed project',
  wishlist_unit: 'Wishlisted unit',
  unwishlist_unit: 'Removed unit from wishlist',
  wishlist_project: 'Wishlisted project',
  unwishlist_project: 'Removed project from wishlist',
  follow_property: 'Followed property',
  unfollow_property: 'Unfollowed property',
  follow_unit: 'Followed unit',
  unfollow_unit: 'Unfollowed unit',
  follow_project: 'Followed project',
  unfollow_project: 'Unfollowed project',
  create_property_presentation: 'Created property presentation',
  create_unit_presentation: 'Created unit presentation',
  create_project_presentation: 'Created project presentation',
};

export const BREAKDOWN_COLORS = {
  views: '#5B8DEF',
  engagement: BRAND,
  sessions: '#7EC8E3',
  presentations: '#E8A87C',
};

export const AVATAR_COLORS = [
  '#5B8DEF',
  '#8FC150',
  '#9B6BDF',
  '#E8A87C',
  '#4ECDC4',
  '#FF6B6B',
  '#45B7D1',
  '#F7B801',
];
